import { AFFILIATES_TOTAL_GROUP_VALUE } from '../Constants/Constants';
type AffiliateData = {
    label: string,
    value: string,
    subAffiliate?:any
}
export const SortAffiliates = (allAffiliatesData: Array<AffiliateData>) => {
    const defaultAffiliates = allAffiliatesData.filter((affiliateValue: { value: string; }, index: number) => {
        return index === 0 || affiliateValue.value === AFFILIATES_TOTAL_GROUP_VALUE;
    })

    const sortedWithSubAffiliates: Array<AffiliateData> = allAffiliatesData.map((data) => {
        if (data.subAffiliate.length > 0) {
            data.subAffiliate.sort((a: { label: string; }, b: { label: any; }) => a.label.localeCompare(b.label));
        }
        return data;
    });

    const sortedAffiliates = sortedWithSubAffiliates.filter((affiliateValue: { label: string; value: string; }, index: number) => {
        return index !== 0 && affiliateValue.value !== AFFILIATES_TOTAL_GROUP_VALUE;
    }).sort((a: { label: string; }, b: { label: any; }) => a.label.localeCompare(b.label));

    allAffiliatesData = [...defaultAffiliates, ...sortedAffiliates];
    return allAffiliatesData;
}